export default function splitString(str: string): string[] {
  return str
    .replace(/\s+/g, ",")
    .replaceAll(";", ",")
    .split(",")
    .filter(Boolean);
}
